import React from 'react';

import { Help } from '@mui/icons-material';
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from '@mui/material';

interface CheckboxInfo {
  label: string;
  module?: string;
}

interface Props {
  shouldShowModule: Map<string, boolean>;
  onChange: (modules: Map<string, boolean>) => void;
}

export class LogModuleChecklist extends React.Component<Props> {
  private checkboxInfoList: CheckboxInfo[] = [];

  constructor(props: Props) {
    super(props);

    const moduleNames = Array.from(this.props.shouldShowModule.keys()).sort();
    this.checkboxInfoList = moduleNames
      .filter((module) => module.length > 0)
      .map((module) => this.createCheckboxForModule(module));

    this.checkboxInfoList.unshift(
      {
        label: 'All modules',
        module: undefined,
      },
      {
        label: 'Without module',
        module: '',
      },
    );

    this.state = {};
  }

  render() {
    return (
      <FormGroup style={{ userSelect: 'none', position: 'relative' }}>
        <Tooltip disableInteractive title="⌘+click on item inverts the selection">
          <div className="log-module-checklist-tooltip">
            <Help fontSize="small" />
          </div>
        </Tooltip>

        {this.checkboxInfoList.map((i) => {
          return (
            <FormControlLabel
              key={i.label}
              control={
                <Checkbox
                  checked={this.isModuleChecked(i.module)}
                  onChange={(e) => {
                    this.onChange(e, i.module);
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                  sx={{ padding: '2px', paddingLeft: '16px', paddingRight: '16px' }}
                />
              }
              label={i.label}
            />
          );
        })}
      </FormGroup>
    );
  }

  private createCheckboxForModule(module: string) {
    return {
      label: module,
      module,
    };
  }

  private areAllModulesChecked(): boolean {
    return !Array.from(this.props.shouldShowModule.values()).includes(false);
  }

  private isModuleChecked(module?: string): boolean {
    if (typeof module === 'string') {
      return this.props.shouldShowModule.get(module) || false;
    }
    return this.areAllModulesChecked();
  }

  private onChange(event: React.ChangeEvent<HTMLInputElement>, moduleToUpdate?: string) {
    const checked = new Map(this.props.shouldShowModule);

    if (typeof moduleToUpdate === 'string') {
      const eventAny = event.nativeEvent as any;
      const invert = eventAny.metaKey === true;

      if (invert) {
        if (checked.get(moduleToUpdate) && !this.areAllModulesChecked()) {
          // Enable everything except this module.
          Array.from(checked.keys()).forEach((module) => {
            checked.set(module, module !== moduleToUpdate);
          });
        } else {
          // Disable everything except this module.
          Array.from(checked.keys()).forEach((module) => {
            checked.set(module, module === moduleToUpdate);
          });
        }
      } else {
        checked.set(moduleToUpdate, !checked.get(moduleToUpdate));
      }
    } else if (this.areAllModulesChecked()) {
      Array.from(checked.keys()).forEach((module) => {
        checked.set(module, false);
      });
    } else {
      Array.from(checked.keys()).forEach((module) => {
        checked.set(module, true);
      });
    }

    this.props.onChange(checked);
  }
}
